// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_41bf2b7f"};